import React from 'react';
export default function RowData({
  leftText,
  rightText,
  bottomBorderOnly = false,
  xPadding = false,
  bolderText = false,
  boldFont = false,
  smallerText = false,
  customUI,
  leftCustomUI,
  alignStart = false,
  paddingY,
  width,
  ...props
}) {
  return (
    <div
      className={`flex items-center justify-between py-3.5 whitespace-nowrap gap-10 print:px-0  ${
        paddingY ? paddingY : ''
      } ${bottomBorderOnly ? 'border-b' : ''} ${xPadding ? 'md:px-6' : ''} ${
        alignStart ? 'items-start gap-10' : ''
      } `}
      {...props}
    >
      {leftText ? (
        <p className="text-small text-deepBlue font-medium capitalize text-left">
          {leftText}
        </p>
      ) : (
        leftCustomUI
      )}
      {rightText ? (
        <p className="text-sm text-[#5C688E] font-normal w-100 text-right capitalize">
          {rightText}
        </p>
      ) : (
        customUI
      )}
    </div>
  );
}
